module.exports = __webpack_public_path__ + "static/media/volume_up.2c1215df.svg";